var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 166 166",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M81.1,2C126.183,2 162,37.817 162,81.1C162,126.183 126.183,161.1 81.1,161.1C37.817,161.1 2,126.183 2,81.1C2,37.817 37.817,2 81.1,2Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07582,0,0,1,-6.0979,8.78809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.106,53.342L107.81,53.342",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "3.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07582,0,0,1,-6.0979,48.1878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.106,53.342L107.81,53.342",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "3.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.57071,0,0,1.46001,-46.4104,3.8438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.106,53.342L107.81,53.342",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.64px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.981c542f3de64f5a1da6cef3aa86f289.svg";
export { ForwardRef as ReactComponent };